export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: AWSDateTime; output: AWSDateTime; }
};

export type Address = {
  __typename?: 'Address';
  address1: Scalars['String']['output'];
  address2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  province: Maybe<Scalars['String']['output']>;
  provinceCode: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  zip: Maybe<Scalars['String']['output']>;
};

export type AddressFilterInput = {
  address1?: InputMaybe<StringFilterInput>;
  address2?: InputMaybe<StringFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  country?: InputMaybe<StringFilterInput>;
  countryCode?: InputMaybe<StringFilterInput>;
  province?: InputMaybe<StringFilterInput>;
  provinceCode?: InputMaybe<StringFilterInput>;
  zip?: InputMaybe<StringFilterInput>;
};

export type AddressOrderByInput = {
  address1?: InputMaybe<SortDirection>;
  address2?: InputMaybe<SortDirection>;
  city?: InputMaybe<SortDirection>;
  country?: InputMaybe<SortDirection>;
  countryCode?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  province?: InputMaybe<SortDirection>;
  provinceCode?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  zip?: InputMaybe<SortDirection>;
};

export type AddressUpdateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilterInput = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BottleService = {
  __typename?: 'BottleService';
  adminNotes: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customerNotes: Maybe<Scalars['String']['output']>;
  date: Scalars['AWSDateTime']['output'];
  event: Maybe<Event>;
  eventId: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  seatId: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  tableId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type BottleServiceFilterInput = {
  AND?: InputMaybe<Array<BottleServiceFilterInput>>;
  NOT?: InputMaybe<Array<BottleServiceFilterInput>>;
  OR?: InputMaybe<Array<BottleServiceFilterInput>>;
  adminNotes?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customerNotes?: InputMaybe<StringFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  event?: InputMaybe<EventFilterInput>;
  eventId?: InputMaybe<IntFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  seatId?: InputMaybe<StringFilterInput>;
  size?: InputMaybe<IntFilterInput>;
  tableId?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BottleServiceOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  event?: InputMaybe<EventOrderByInput>;
  eventId?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  seatId?: InputMaybe<SortDirection>;
  size?: InputMaybe<SortDirection>;
  tableId?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type BottleServicePagination = {
  __typename?: 'BottleServicePagination';
  count: Scalars['Int']['output'];
  nodes: Array<BottleService>;
};

export type DateTimeFilterInput = {
  equals?: InputMaybe<Scalars['AWSDateTime']['input']>;
  gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  gte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  in?: InputMaybe<Array<Scalars['AWSDateTime']['input']>>;
  lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['AWSDateTime']['input']>>;
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  amount: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  events: Maybe<EventPagination>;
  expireAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  isApplicableToAllEvents: Scalars['Boolean']['output'];
  maxUse: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfTicketsAppliedInOrder: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  venueId: Scalars['Int']['output'];
};


export type DiscountCodeEventsArgs = {
  filters?: InputMaybe<EventFilterInput>;
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscountCodeCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expireAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isApplicableToAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
  maxUse?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfTicketsAppliedInOrder?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscountCodeFilterInput = {
  AND?: InputMaybe<Array<DiscountCodeFilterInput>>;
  NOT?: InputMaybe<Array<DiscountCodeFilterInput>>;
  OR?: InputMaybe<Array<DiscountCodeFilterInput>>;
  amount?: InputMaybe<IntFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  eventDiscountCodes?: InputMaybe<EventDiscountCodeListRelationFilterInput>;
  expireAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  isApplicableToAllEvents?: InputMaybe<BooleanFilterInput>;
  maxUse?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  numberOfTicketsAppliedInOrder?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
};

export type DiscountCodeOrderByInput = {
  amount?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  expireAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isApplicableToAllEvents?: InputMaybe<SortDirection>;
  maxUse?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  numberOfTicketsAppliedInOrder?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venueId?: InputMaybe<SortDirection>;
};

export type DiscountCodePagination = {
  __typename?: 'DiscountCodePagination';
  count: Scalars['Int']['output'];
  nodes: Array<DiscountCode>;
};

export type DiscountCodeUpdateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expireAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isApplicableToAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
  maxUse?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfTicketsAppliedInOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Event = {
  __typename?: 'Event';
  ageLimit: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  date: Scalars['AWSDateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  discountCodes: Maybe<DiscountCodePagination>;
  doorTime: Scalars['Int']['output'];
  eventOccuranceId: Maybe<Scalars['String']['output']>;
  eventTemplateId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  image: Maybe<Image>;
  imageId: Maybe<Scalars['Int']['output']>;
  isPasswordProtected: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  presalePasswords: Maybe<PresalePasswordPagination>;
  previewId: Maybe<Scalars['String']['output']>;
  publishAt: Scalars['AWSDateTime']['output'];
  seatMap: Maybe<SeatMap>;
  seatMapId: Maybe<Scalars['Int']['output']>;
  sendTicketsAt: Maybe<Scalars['AWSDateTime']['output']>;
  status: EventStatus;
  ticketDescription: Maybe<Scalars['String']['output']>;
  ticketPools: Maybe<TicketPoolPagination>;
  timezone: Maybe<Scalars['String']['output']>;
  type: EventType;
  updatedAt: Scalars['AWSDateTime']['output'];
  venue: Maybe<Venue>;
  venueId: Scalars['Int']['output'];
  youtubeUrl: Maybe<Scalars['String']['output']>;
};


export type EventDiscountCodesArgs = {
  filters?: InputMaybe<DiscountCodeFilterInput>;
  orderBy?: InputMaybe<Array<DiscountCodeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type EventPresalePasswordsArgs = {
  filters?: InputMaybe<PresalePasswordFilterInput>;
  orderBy?: InputMaybe<Array<PresalePasswordOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTicketPoolsArgs = {
  filters?: InputMaybe<TicketPoolFilterInput>;
  orderBy?: InputMaybe<Array<TicketPoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCreateInput = {
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountCodeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  doorTime?: InputMaybe<Scalars['Int']['input']>;
  eventTemplateId?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  presalePasswords?: InputMaybe<Array<PresalePasswordCreateInput>>;
  publishAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  seatMapId?: InputMaybe<Scalars['Int']['input']>;
  sendTicketsAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<EventStatus>;
  ticketDescription?: InputMaybe<Scalars['String']['input']>;
  ticketPools?: InputMaybe<Array<TicketPoolCreateInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventType>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EventDiscountCode = {
  __typename?: 'EventDiscountCode';
  discountCodeId: Scalars['Int']['output'];
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type EventDiscountCodeFilterInput = {
  AND?: InputMaybe<Array<EventDiscountCodeFilterInput>>;
  NOT?: InputMaybe<Array<EventDiscountCodeFilterInput>>;
  OR?: InputMaybe<Array<EventDiscountCodeFilterInput>>;
  discountCodeId?: InputMaybe<IntFilterInput>;
  eventId?: InputMaybe<IntFilterInput>;
};

export type EventDiscountCodeListRelationFilterInput = {
  every?: InputMaybe<EventDiscountCodeFilterInput>;
  none?: InputMaybe<EventDiscountCodeFilterInput>;
  some?: InputMaybe<EventDiscountCodeFilterInput>;
};

export type EventFilterInput = {
  AND?: InputMaybe<Array<EventFilterInput>>;
  NOT?: InputMaybe<Array<EventFilterInput>>;
  OR?: InputMaybe<Array<EventFilterInput>>;
  ageLimit?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  discountCodes?: InputMaybe<EventDiscountCodeListRelationFilterInput>;
  doorTime?: InputMaybe<IntFilterInput>;
  eventTemplateId?: InputMaybe<IntFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  presalePasswords?: InputMaybe<PresalePasswordListRelationFilterInput>;
  publishAt?: InputMaybe<DateTimeFilterInput>;
  seatMap?: InputMaybe<SeatMapFilterInput>;
  seatMapId?: InputMaybe<IntFilterInput>;
  sendTicketsAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<EventStatusEnumFilter>;
  ticketDescription?: InputMaybe<StringFilterInput>;
  ticketPools?: InputMaybe<TicketPoolListRelationFilterInput>;
  type?: InputMaybe<EventTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venue?: InputMaybe<VenueFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
  youtubeUrl?: InputMaybe<StringFilterInput>;
};

export type EventListRelationFilterInput = {
  every?: InputMaybe<EventFilterInput>;
  none?: InputMaybe<EventFilterInput>;
  some?: InputMaybe<EventFilterInput>;
};

export type EventOccurrence = {
  __typename?: 'EventOccurrence';
  date: Scalars['AWSDateTime']['output'];
  event: Event;
  id: Scalars['String']['output'];
  ticketsAggregation: Maybe<EventTicketAggregation>;
};

export type EventOccurrenceFilterInput = {
  AND?: InputMaybe<Array<EventOccurrenceFilterInput>>;
  NOT?: InputMaybe<Array<EventOccurrenceFilterInput>>;
  OR?: InputMaybe<Array<EventOccurrenceFilterInput>>;
  ageLimit?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  discountCodes?: InputMaybe<EventDiscountCodeListRelationFilterInput>;
  doorTime?: InputMaybe<IntFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  presalePasswords?: InputMaybe<PresalePasswordListRelationFilterInput>;
  publishAt?: InputMaybe<DateTimeFilterInput>;
  seatMap?: InputMaybe<SeatMapFilterInput>;
  seatMapId?: InputMaybe<IntFilterInput>;
  sendTicketsAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<EventStatusEnumFilter>;
  ticketDescription?: InputMaybe<StringFilterInput>;
  ticketPools?: InputMaybe<TicketPoolListRelationFilterInput>;
  type?: InputMaybe<EventTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venue?: InputMaybe<VenueFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
  youtubeUrl?: InputMaybe<StringFilterInput>;
};

export type EventOccurrencesList = {
  __typename?: 'EventOccurrencesList';
  nodes: Array<EventOccurrence>;
};

export type EventOrderByInput = {
  ageLimit?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  doorTime?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  publishAt?: InputMaybe<SortDirection>;
  seatMap?: InputMaybe<SeatMapOrderByInput>;
  sendTicketsAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  ticketDescription?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venue?: InputMaybe<VenueOrderByInput>;
};

export type EventPagination = {
  __typename?: 'EventPagination';
  count: Scalars['Int']['output'];
  nodes: Array<Event>;
};

export enum EventStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type EventStatusEnumFilter = {
  equals?: InputMaybe<EventStatus>;
  in?: InputMaybe<Array<EventStatus>>;
  not?: InputMaybe<EventStatusEnumFilter>;
  notIn?: InputMaybe<Array<EventStatus>>;
};

export type EventTemplate = {
  __typename?: 'EventTemplate';
  ageLimit: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  date: Scalars['AWSDateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  discountCodes: Maybe<DiscountCodePagination>;
  doorTime: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Maybe<Image>;
  imageId: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  presalePasswords: Maybe<PresalePasswordPagination>;
  publishAt: Scalars['AWSDateTime']['output'];
  recurringSettings: Maybe<RecurringSettings>;
  recurringSettingsId: Maybe<Scalars['Int']['output']>;
  seatMap: Maybe<SeatMap>;
  seatMapId: Maybe<Scalars['Int']['output']>;
  sendTicketsAt: Maybe<Scalars['AWSDateTime']['output']>;
  status: EventStatus;
  ticketDescription: Maybe<Scalars['String']['output']>;
  ticketPools: Maybe<TicketPoolPagination>;
  timezone: Maybe<Scalars['String']['output']>;
  type: EventType;
  updatedAt: Scalars['AWSDateTime']['output'];
  venue: Maybe<Venue>;
  venueId: Scalars['Int']['output'];
  youtubeUrl: Maybe<Scalars['String']['output']>;
};


export type EventTemplateDiscountCodesArgs = {
  filters?: InputMaybe<DiscountCodeFilterInput>;
  orderBy?: InputMaybe<Array<DiscountCodeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTemplatePresalePasswordsArgs = {
  filters?: InputMaybe<PresalePasswordFilterInput>;
  orderBy?: InputMaybe<Array<PresalePasswordOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type EventTemplateTicketPoolsArgs = {
  filters?: InputMaybe<TicketPoolFilterInput>;
  orderBy?: InputMaybe<Array<TicketPoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EventTemplateCreateInput = {
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountCodeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  doorTime?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  presalePasswords?: InputMaybe<Array<PresalePasswordCreateInput>>;
  publishAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  recurringSettings?: InputMaybe<RecurringSettingsCreateInput>;
  seatMapId?: InputMaybe<Scalars['Int']['input']>;
  sendTicketsAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<EventStatus>;
  ticketDescription?: InputMaybe<Scalars['String']['input']>;
  ticketPools?: InputMaybe<Array<TicketPoolCreateInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventType>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EventTemplateFilterInput = {
  AND?: InputMaybe<Array<EventFilterInput>>;
  NOT?: InputMaybe<Array<EventFilterInput>>;
  OR?: InputMaybe<Array<EventFilterInput>>;
  ageLimit?: InputMaybe<IntFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  discountCodes?: InputMaybe<EventDiscountCodeListRelationFilterInput>;
  doorTime?: InputMaybe<IntFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  presalePasswords?: InputMaybe<PresalePasswordListRelationFilterInput>;
  publishAt?: InputMaybe<DateTimeFilterInput>;
  recurringSettings?: InputMaybe<RecurringSettingsFilterInput>;
  recurringSettingsId?: InputMaybe<IntFilterInput>;
  seatMap?: InputMaybe<SeatMapFilterInput>;
  seatMapId?: InputMaybe<IntFilterInput>;
  sendTicketsAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<EventStatusEnumFilter>;
  ticketDescription?: InputMaybe<StringFilterInput>;
  ticketPools?: InputMaybe<TicketPoolListRelationFilterInput>;
  type?: InputMaybe<EventTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venue?: InputMaybe<VenueFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
  youtubeUrl?: InputMaybe<StringFilterInput>;
};

export type EventTemplateListRelationFilterInput = {
  every?: InputMaybe<EventTemplateFilterInput>;
  none?: InputMaybe<EventTemplateFilterInput>;
  some?: InputMaybe<EventTemplateFilterInput>;
};

export type EventTemplateOrderByInput = {
  ageLimit?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  doorTime?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  publishAt?: InputMaybe<SortDirection>;
  recurringSettings?: InputMaybe<RecurringSettingsOrderByInput>;
  seatMap?: InputMaybe<SeatMapOrderByInput>;
  sendTicketsAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  ticketDescription?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venue?: InputMaybe<VenueOrderByInput>;
};

export type EventTemplatePagination = {
  __typename?: 'EventTemplatePagination';
  count: Scalars['Int']['output'];
  nodes: Array<EventTemplate>;
};

export type EventTemplateTicketAggregation = {
  __typename?: 'EventTemplateTicketAggregation';
  availableCount: Scalars['Int']['output'];
  tickets: Array<TicketAggregation>;
};

export type EventTemplateUpdateInput = {
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountCodeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  doorTime?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  presalePasswords?: InputMaybe<Array<InputMaybe<PresalePasswordCreateInput>>>;
  publishAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  recurringSettings?: InputMaybe<RecurringSettingsCreateInput>;
  seatMapId?: InputMaybe<Scalars['Int']['input']>;
  sendTicketsAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<EventStatus>;
  ticketDescription?: InputMaybe<Scalars['String']['input']>;
  ticketPools?: InputMaybe<Array<InputMaybe<TicketPoolCreateInput>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventType>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EventTicketAggregation = {
  __typename?: 'EventTicketAggregation';
  availableCount: Scalars['Int']['output'];
  tickets: Array<TicketAggregation>;
};

export enum EventType {
  NONTICKETED = 'NONTICKETED',
  TICKETED = 'TICKETED'
}

export type EventTypeEnumFilter = {
  equals?: InputMaybe<EventType>;
  in?: InputMaybe<Array<EventType>>;
  not?: InputMaybe<EventTypeEnumFilter>;
  notIn?: InputMaybe<Array<EventType>>;
};

export type EventUpdateInput = {
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountCodeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  doorTime?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  presalePasswords?: InputMaybe<Array<InputMaybe<PresalePasswordCreateInput>>>;
  publishAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  seatMapId?: InputMaybe<Scalars['Int']['input']>;
  sendTicketsAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<EventStatus>;
  ticketDescription?: InputMaybe<Scalars['String']['input']>;
  ticketPools?: InputMaybe<Array<InputMaybe<TicketPoolCreateInput>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventType>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type File = {
  __typename?: 'File';
  bucket: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  key: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type FloatFilterInput = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type Image = {
  __typename?: 'Image';
  bucket: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  key: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type ImageCreateInput = {
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type ImageCreatePayload = {
  __typename?: 'ImageCreatePayload';
  image: Image;
  uploadUrl: Scalars['String']['output'];
};

export type ImageFilterInput = {
  AND?: InputMaybe<Array<ImageFilterInput>>;
  NOT?: InputMaybe<Array<ImageFilterInput>>;
  OR?: InputMaybe<Array<ImageFilterInput>>;
  bucket?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  size?: InputMaybe<IntFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IntFilterInput = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MeUser = UserInterface & {
  __typename?: 'MeUser';
  createdAt: Scalars['AWSDateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  role: UserRole;
  updatedAt: Scalars['AWSDateTime']['output'];
  userPermissions: Array<Permission>;
  venuePermissions: Array<Permission>;
};

export type Mutation = {
  __typename?: 'Mutation';
  discountCodeCreate: Maybe<DiscountCode>;
  discountCodeDelete: Maybe<DiscountCode>;
  discountCodeUpdate: Maybe<DiscountCode>;
  eventCreate: Maybe<Event>;
  eventDelete: Maybe<Event>;
  eventTemplateCreate: Maybe<EventTemplate>;
  eventTemplateDelete: Maybe<EventTemplate>;
  eventTemplateUpdate: Maybe<EventTemplate>;
  eventUpdate: Maybe<Event>;
  imageCreate: Maybe<ImageCreatePayload>;
  orderCreate: Maybe<Order>;
  orderUpdate: Maybe<Order>;
  ordersExport: Maybe<File>;
  organizationCreate: Maybe<Organization>;
  organizationDelete: Maybe<Organization>;
  organizationUpdate: Maybe<Organization>;
  paymentTerminalCreate: Maybe<PaymentTerminal>;
  paymentTerminalDelete: Maybe<PaymentTerminal>;
  presalePasswordVerify: Scalars['Boolean']['output'];
  refundCreate: Maybe<Refund>;
  seatMapCreate: Maybe<SeatMap>;
  ticketScan: Maybe<Ticket>;
  ticketScanByOrderId: Maybe<Scalars['Boolean']['output']>;
  ticketTemplateCreate: Maybe<TicketTemplate>;
  ticketTemplateDelete: Maybe<TicketTemplate>;
  ticketTemplateUpdate: Maybe<TicketTemplate>;
  ticketUpdate: Maybe<Ticket>;
  userCreate: Maybe<User>;
  userDelete: Maybe<User>;
  userUpdate: Maybe<User>;
  venueCreate: Maybe<Venue>;
  venueDelete: Maybe<Scalars['Boolean']['output']>;
  venueUpdate: Maybe<Venue>;
  venueUserCreate: Maybe<VenueUser>;
  venueUserDelete: Maybe<VenueUser>;
  venueUserUpdate: Maybe<VenueUser>;
};


export type MutationDiscountCodeCreateArgs = {
  input: DiscountCodeCreateInput;
};


export type MutationDiscountCodeDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDiscountCodeUpdateArgs = {
  id: Scalars['Int']['input'];
  input: DiscountCodeUpdateInput;
};


export type MutationEventCreateArgs = {
  input: EventCreateInput;
};


export type MutationEventDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEventTemplateCreateArgs = {
  input: EventTemplateCreateInput;
};


export type MutationEventTemplateDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationEventTemplateUpdateArgs = {
  id: Scalars['Int']['input'];
  input: EventTemplateUpdateInput;
};


export type MutationEventUpdateArgs = {
  id: Scalars['Int']['input'];
  input: EventUpdateInput;
};


export type MutationImageCreateArgs = {
  input: ImageCreateInput;
};


export type MutationOrderCreateArgs = {
  input: OrderCreateInput;
};


export type MutationOrderUpdateArgs = {
  input: OrderCreateInput;
  token: Scalars['String']['input'];
};


export type MutationOrdersExportArgs = {
  filters?: InputMaybe<OrderFilterInput>;
  orderBy?: InputMaybe<Array<OrderOrderByInput>>;
};


export type MutationOrganizationCreateArgs = {
  input: OrganizationCreateInput;
};


export type MutationOrganizationDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOrganizationUpdateArgs = {
  id: Scalars['Int']['input'];
  input: OrganizationUpdateInput;
};


export type MutationPaymentTerminalCreateArgs = {
  input: PaymentTerminalCreateInput;
};


export type MutationPaymentTerminalDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPresalePasswordVerifyArgs = {
  input: PresalePasswordVerifyInput;
};


export type MutationRefundCreateArgs = {
  input: RefundCreateInput;
};


export type MutationSeatMapCreateArgs = {
  input: SeatMapCreateInput;
};


export type MutationTicketScanArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  eventOccurrenceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTicketScanByOrderIdArgs = {
  eventOccurrenceId: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationTicketTemplateCreateArgs = {
  input: TicketTemplateCreateInput;
};


export type MutationTicketTemplateDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationTicketTemplateUpdateArgs = {
  id: Scalars['Int']['input'];
  input: TicketTemplateUpdateInput;
};


export type MutationTicketUpdateArgs = {
  id: Scalars['Int']['input'];
  input: TicketUpdateInput;
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUserUpdateArgs = {
  id: Scalars['Int']['input'];
  input: UserUpdateInput;
};


export type MutationVenueCreateArgs = {
  input: VenueCreateInput;
};


export type MutationVenueDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVenueUpdateArgs = {
  id: Scalars['Int']['input'];
  input: VenueUpdateInput;
};


export type MutationVenueUserCreateArgs = {
  input: VenueUserCreateInput;
};


export type MutationVenueUserDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationVenueUserUpdateArgs = {
  id: Scalars['Int']['input'];
  input: VenueUserUpdateInput;
};

export type Order = {
  __typename?: 'Order';
  autoCheckIn: Scalars['Boolean']['output'];
  checkoutUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customerNotes: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountCode: Maybe<DiscountCode>;
  discountCodeId: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  expireAt: Maybe<Scalars['AWSDateTime']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  newsletterAgree: Scalars['Boolean']['output'];
  orderNumber: Maybe<Scalars['String']['output']>;
  paymentFeeAmount: Scalars['Float']['output'];
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentTerminalId: Maybe<Scalars['Int']['output']>;
  paymentType: Maybe<PaymentType>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  platformFeeAmount: Scalars['Float']['output'];
  platformFeeSubtotalAmount: Scalars['Float']['output'];
  receiptUrl: Maybe<Scalars['String']['output']>;
  refunds: Maybe<RefundPagination>;
  sendReceipt: Scalars['Boolean']['output'];
  status: Maybe<OrderStatus>;
  subtotalAmount: Scalars['Float']['output'];
  termsAgree: Scalars['Boolean']['output'];
  tickets: Maybe<TicketPagination>;
  token: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  venueFeeAmount: Scalars['Float']['output'];
  venueFeeSubtotalAmount: Scalars['Float']['output'];
};


export type OrderRefundsArgs = {
  filters?: InputMaybe<RefundFilterInput>;
  orderBy?: InputMaybe<Array<RefundOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderTicketsArgs = {
  filters?: InputMaybe<TicketFilterInput>;
  orderBy?: InputMaybe<Array<TicketOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderCreateInput = {
  autoCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  newsletterAgree?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTerminalId?: InputMaybe<Scalars['Int']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  presalePassword?: InputMaybe<Scalars['String']['input']>;
  sendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OrderStatus>;
  termsAgree?: InputMaybe<Scalars['Boolean']['input']>;
  tickets?: InputMaybe<Array<TicketCreateInput>>;
};

export type OrderFilterInput = {
  AND?: InputMaybe<Array<OrderFilterInput>>;
  NOT?: InputMaybe<Array<OrderFilterInput>>;
  OR?: InputMaybe<Array<OrderFilterInput>>;
  checkoutUrl?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  customerNotes?: InputMaybe<StringFilterInput>;
  discountAmount?: InputMaybe<FloatFilterInput>;
  discountCodeId?: InputMaybe<IntFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  expireAt?: InputMaybe<DateTimeFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  newsletterAgree?: InputMaybe<BooleanFilterInput>;
  orderNumber?: InputMaybe<StringFilterInput>;
  paymentFeeAmount?: InputMaybe<FloatFilterInput>;
  phoneNumber?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<OrderStatusEnumFilter>;
  subtotalAmount?: InputMaybe<FloatFilterInput>;
  termsAgree?: InputMaybe<BooleanFilterInput>;
  tickets?: InputMaybe<TicketListRelationFilterInput>;
  totalAmount?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venueFeeAmount?: InputMaybe<FloatFilterInput>;
};

export type OrderOrderByInput = {
  checkoutUrl?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  customerNotes?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  discountCodeId?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  expireAt?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  newsletterAgree?: InputMaybe<SortDirection>;
  orderNumber?: InputMaybe<SortDirection>;
  paymentFeeAmount?: InputMaybe<SortDirection>;
  phoneNumber?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subtotalAmount?: InputMaybe<SortDirection>;
  termsAgree?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venueFeeAmount?: InputMaybe<SortDirection>;
};

export type OrderPagination = {
  __typename?: 'OrderPagination';
  count: Scalars['Int']['output'];
  nodes: Array<Order>;
};

export enum OrderStatus {
  CHECKOUT = 'CHECKOUT',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED'
}

export type OrderStatusEnumFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<OrderStatusEnumFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type Organization = {
  __typename?: 'Organization';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type OrganizationCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type OrganizationPagination = {
  __typename?: 'OrganizationPagination';
  count: Scalars['Int']['output'];
  nodes: Array<Organization>;
};

export type OrganizationUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationsFilterInput = {
  name?: InputMaybe<StringFilterInput>;
};

export type PaymentTerminal = {
  __typename?: 'PaymentTerminal';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  serialNumber: Maybe<Scalars['String']['output']>;
  stripeTerminalId: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  venueId: Scalars['Int']['output'];
};

export type PaymentTerminalCreateInput = {
  name: Scalars['String']['input'];
  stripeTerminalRegistrationCode: Scalars['String']['input'];
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentTerminalFilterInput = {
  AND?: InputMaybe<Array<PaymentTerminalFilterInput>>;
  NOT?: InputMaybe<Array<PaymentTerminalFilterInput>>;
  OR?: InputMaybe<Array<PaymentTerminalFilterInput>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  serialNumber?: InputMaybe<StringFilterInput>;
  stripeTerminalId?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venue?: InputMaybe<VenueFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
};

export type PaymentTerminalOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  serialNumber?: InputMaybe<SortDirection>;
  stripeTerminalId?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venueId?: InputMaybe<SortDirection>;
};

export type PaymentTerminalPagination = {
  __typename?: 'PaymentTerminalPagination';
  count: Scalars['Int']['output'];
  nodes: Array<PaymentTerminal>;
};

export enum PaymentType {
  CASH = 'CASH',
  POS = 'POS',
  STRIPE_CHECKOUT = 'STRIPE_CHECKOUT',
  STRIPE_TERMINAL = 'STRIPE_TERMINAL'
}

export enum Permission {
  BOTTLE_SERVICE_LIST = 'BOTTLE_SERVICE_LIST',
  BOTTLE_SERVICE_READ = 'BOTTLE_SERVICE_READ',
  DISCOUNT_CODE_CREATE = 'DISCOUNT_CODE_CREATE',
  DISCOUNT_CODE_DELETE = 'DISCOUNT_CODE_DELETE',
  DISCOUNT_CODE_LIST = 'DISCOUNT_CODE_LIST',
  DISCOUNT_CODE_READ = 'DISCOUNT_CODE_READ',
  DISCOUNT_CODE_UPDATE = 'DISCOUNT_CODE_UPDATE',
  EVENT_CREATE = 'EVENT_CREATE',
  EVENT_DELETE = 'EVENT_DELETE',
  EVENT_LIST = 'EVENT_LIST',
  EVENT_READ = 'EVENT_READ',
  EVENT_UPDATE = 'EVENT_UPDATE',
  IMAGE_CREATE = 'IMAGE_CREATE',
  ORDER_CHECKOUT_CASH = 'ORDER_CHECKOUT_CASH',
  ORDER_CHECKOUT_POS = 'ORDER_CHECKOUT_POS',
  ORDER_CHECKOUT_STRIPE_TERMINAL = 'ORDER_CHECKOUT_STRIPE_TERMINAL',
  ORDER_CREATE = 'ORDER_CREATE',
  ORDER_LIST = 'ORDER_LIST',
  ORDER_READ = 'ORDER_READ',
  ORDER_UPDATE = 'ORDER_UPDATE',
  ORGANIZATION_CREATE = 'ORGANIZATION_CREATE',
  ORGANIZATION_DELETE = 'ORGANIZATION_DELETE',
  ORGANIZATION_LIST = 'ORGANIZATION_LIST',
  ORGANIZATION_READ = 'ORGANIZATION_READ',
  ORGANIZATION_UPDATE = 'ORGANIZATION_UPDATE',
  PAYMENT_TERMINAL_CREATE = 'PAYMENT_TERMINAL_CREATE',
  PAYMENT_TERMINAL_DELETE = 'PAYMENT_TERMINAL_DELETE',
  PAYMENT_TERMINAL_LIST = 'PAYMENT_TERMINAL_LIST',
  PAYMENT_TERMINAL_READ = 'PAYMENT_TERMINAL_READ',
  PRESALE_PASSWORD_READ = 'PRESALE_PASSWORD_READ',
  REFUND_CREATE = 'REFUND_CREATE',
  REFUND_LIST = 'REFUND_LIST',
  SEAT_MAP_CREATE = 'SEAT_MAP_CREATE',
  SEAT_MAP_LIST = 'SEAT_MAP_LIST',
  SETTINGS_EMBED_READ = 'SETTINGS_EMBED_READ',
  SIGN_UP_OPTIONS_LIST = 'SIGN_UP_OPTIONS_LIST',
  TICKET_LIST = 'TICKET_LIST',
  TICKET_POOL_READ = 'TICKET_POOL_READ',
  TICKET_READ = 'TICKET_READ',
  TICKET_TEMPLATE_CREATE = 'TICKET_TEMPLATE_CREATE',
  TICKET_TEMPLATE_DELETE = 'TICKET_TEMPLATE_DELETE',
  TICKET_TEMPLATE_LIST = 'TICKET_TEMPLATE_LIST',
  TICKET_TEMPLATE_READ = 'TICKET_TEMPLATE_READ',
  TICKET_TEMPLATE_UPDATE = 'TICKET_TEMPLATE_UPDATE',
  TICKET_UPDATE = 'TICKET_UPDATE',
  USER_CREATE = 'USER_CREATE',
  USER_DELETE = 'USER_DELETE',
  USER_LIST = 'USER_LIST',
  USER_READ = 'USER_READ',
  USER_UPDATE = 'USER_UPDATE',
  VENUE_CREATE = 'VENUE_CREATE',
  VENUE_DELETE = 'VENUE_DELETE',
  VENUE_LIST = 'VENUE_LIST',
  VENUE_READ = 'VENUE_READ',
  VENUE_UPDATE = 'VENUE_UPDATE',
  VENUE_USER_CREATE = 'VENUE_USER_CREATE',
  VENUE_USER_DELETE = 'VENUE_USER_DELETE',
  VENUE_USER_LIST = 'VENUE_USER_LIST',
  VENUE_USER_READ = 'VENUE_USER_READ',
  VENUE_USER_UPDATE = 'VENUE_USER_UPDATE'
}

export type PresalePassword = {
  __typename?: 'PresalePassword';
  createdAt: Scalars['AWSDateTime']['output'];
  eventId: Maybe<Scalars['Int']['output']>;
  expireAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PresalePasswordCreateInput = {
  expireAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type PresalePasswordFilterInput = {
  AND?: InputMaybe<Array<PresalePasswordFilterInput>>;
  NOT?: InputMaybe<Array<PresalePasswordFilterInput>>;
  OR?: InputMaybe<Array<PresalePasswordFilterInput>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  event?: InputMaybe<EventFilterInput>;
  eventId?: InputMaybe<IntFilterInput>;
  expireAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  password?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PresalePasswordListRelationFilterInput = {
  every?: InputMaybe<PresalePasswordFilterInput>;
  none?: InputMaybe<PresalePasswordFilterInput>;
  some?: InputMaybe<PresalePasswordFilterInput>;
};

export type PresalePasswordOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  eventId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  password?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type PresalePasswordPagination = {
  __typename?: 'PresalePasswordPagination';
  count: Scalars['Int']['output'];
  nodes: Array<PresalePassword>;
};

export type PresalePasswordVerifyInput = {
  eventOccurrenceId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum PriceDisplay {
  ALL_FEES = 'ALL_FEES',
  SPLIT_FEES = 'SPLIT_FEES'
}

export type Query = {
  __typename?: 'Query';
  bottleService: Maybe<BottleService>;
  bottleServices: Maybe<BottleServicePagination>;
  discountCode: Maybe<DiscountCode>;
  discountCodes: Maybe<DiscountCodePagination>;
  event: Maybe<Event>;
  eventOccurrence: Maybe<EventOccurrence>;
  eventOccurrences: Maybe<EventOccurrencesList>;
  eventTemplate: Maybe<EventTemplate>;
  eventTemplates: Maybe<EventTemplatePagination>;
  events: Maybe<EventPagination>;
  me: Maybe<MeUser>;
  order: Maybe<Order>;
  orderByToken: Maybe<Order>;
  orders: Maybe<OrderPagination>;
  organization: Maybe<Organization>;
  organizations: Maybe<OrganizationPagination>;
  paymentTerminals: Maybe<PaymentTerminalPagination>;
  seatMaps: Maybe<SeatMapPagination>;
  ticket: Maybe<Ticket>;
  ticketTemplate: Maybe<TicketTemplate>;
  ticketTemplates: Maybe<TicketTemplatePagination>;
  tickets: Maybe<TicketPagination>;
  user: Maybe<User>;
  users: Maybe<UserPagination>;
  venue: Maybe<Venue>;
  venueUser: Maybe<VenueUser>;
  venueUsers: Maybe<VenueUserPagination>;
  venues: Maybe<VenuePagination>;
};


export type QueryBottleServiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBottleServicesArgs = {
  filters?: InputMaybe<BottleServiceFilterInput>;
  orderBy?: InputMaybe<Array<BottleServiceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDiscountCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiscountCodesArgs = {
  filters?: InputMaybe<DiscountCodeFilterInput>;
  orderBy?: InputMaybe<Array<DiscountCodeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventOccurrenceArgs = {
  id: Scalars['String']['input'];
  isPreview: Scalars['Boolean']['input'];
};


export type QueryEventOccurrencesArgs = {
  end: Scalars['AWSDateTime']['input'];
  filters?: InputMaybe<EventOccurrenceFilterInput>;
  start: Scalars['AWSDateTime']['input'];
};


export type QueryEventTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEventTemplatesArgs = {
  filters?: InputMaybe<EventFilterInput>;
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventsArgs = {
  filters?: InputMaybe<EventFilterInput>;
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrderByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryOrdersArgs = {
  filters?: InputMaybe<OrderFilterInput>;
  orderBy?: InputMaybe<Array<OrderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationsArgs = {
  filters?: InputMaybe<OrganizationsFilterInput>;
  orderBy?: InputMaybe<Array<OrganizationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentTerminalsArgs = {
  filters?: InputMaybe<PaymentTerminalFilterInput>;
  orderBy?: InputMaybe<Array<PaymentTerminalOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySeatMapsArgs = {
  filters?: InputMaybe<SeatMapFilterInput>;
  orderBy?: InputMaybe<Array<SeatMapOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTicketArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTicketTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTicketTemplatesArgs = {
  filters?: InputMaybe<TicketTemplateFilterInput>;
  orderBy?: InputMaybe<Array<TicketTemplateOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTicketsArgs = {
  filters?: InputMaybe<TicketFilterInput>;
  orderBy?: InputMaybe<Array<TicketOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserFilterInput>;
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVenueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVenueUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVenueUsersArgs = {
  filters?: InputMaybe<VenueUserFilterInput>;
  orderBy?: InputMaybe<Array<VenueUserOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVenuesArgs = {
  filters?: InputMaybe<VenueFilterInput>;
  orderBy?: InputMaybe<Array<VenueOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum QueryMode {
  default = 'default',
  insensitive = 'insensitive'
}

export type RecurringSettings = {
  __typename?: 'RecurringSettings';
  createdAt: Scalars['AWSDateTime']['output'];
  endAt: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['Int']['output'];
  isOnFriday: Scalars['Boolean']['output'];
  isOnMonday: Scalars['Boolean']['output'];
  isOnSaturday: Scalars['Boolean']['output'];
  isOnSunday: Scalars['Boolean']['output'];
  isOnThursday: Scalars['Boolean']['output'];
  isOnTuesday: Scalars['Boolean']['output'];
  isOnWednesday: Scalars['Boolean']['output'];
  maxOccurrences: Maybe<Scalars['Int']['output']>;
  monthRepeatMode: Maybe<RecurringSettingsMonthRepeatMode>;
  separator: RecurringSettingsSeparator;
  separatorCount: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RecurringSettingsCreateInput = {
  endAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isOnFriday?: InputMaybe<Scalars['Boolean']['input']>;
  isOnMonday?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSunday?: InputMaybe<Scalars['Boolean']['input']>;
  isOnThursday?: InputMaybe<Scalars['Boolean']['input']>;
  isOnTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  isOnWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  maxOccurrences?: InputMaybe<Scalars['Int']['input']>;
  monthRepeatMode?: InputMaybe<RecurringSettingsMonthRepeatMode>;
  separator: RecurringSettingsSeparator;
  separatorCount: Scalars['Int']['input'];
};

export type RecurringSettingsFilterInput = {
  AND?: InputMaybe<Array<RecurringSettingsFilterInput>>;
  NOT?: InputMaybe<Array<RecurringSettingsFilterInput>>;
  OR?: InputMaybe<Array<RecurringSettingsFilterInput>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  endAt?: InputMaybe<DateTimeFilterInput>;
  events?: InputMaybe<EventListRelationFilterInput>;
  isOnFriday?: InputMaybe<BooleanFilterInput>;
  isOnMonday?: InputMaybe<BooleanFilterInput>;
  isOnSaturday?: InputMaybe<BooleanFilterInput>;
  isOnSunday?: InputMaybe<BooleanFilterInput>;
  isOnThursday?: InputMaybe<BooleanFilterInput>;
  isOnTuesday?: InputMaybe<BooleanFilterInput>;
  isOnWednesday?: InputMaybe<BooleanFilterInput>;
  maxOccurrences?: InputMaybe<IntFilterInput>;
  separator?: InputMaybe<RecurringSettingsSeparatorEnumFilter>;
  separatorCount?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export enum RecurringSettingsMonthRepeatMode {
  LAST_WEEK_DAY = 'LAST_WEEK_DAY',
  MONTH_DAY = 'MONTH_DAY',
  WEEK_DAY = 'WEEK_DAY'
}

export type RecurringSettingsOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  endAt?: InputMaybe<SortDirection>;
  isOnFriday?: InputMaybe<SortDirection>;
  isOnMonday?: InputMaybe<SortDirection>;
  isOnSaturday?: InputMaybe<SortDirection>;
  isOnSunday?: InputMaybe<SortDirection>;
  isOnThursday?: InputMaybe<SortDirection>;
  isOnTuesday?: InputMaybe<SortDirection>;
  isOnWednesday?: InputMaybe<SortDirection>;
  maxOccurrences?: InputMaybe<SortDirection>;
  separator?: InputMaybe<SortDirection>;
  separatorCount?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum RecurringSettingsSeparator {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export type RecurringSettingsSeparatorEnumFilter = {
  equals?: InputMaybe<RecurringSettingsSeparator>;
  in?: InputMaybe<Array<RecurringSettingsSeparator>>;
  not?: InputMaybe<RecurringSettingsSeparatorEnumFilter>;
  notIn?: InputMaybe<Array<RecurringSettingsSeparator>>;
};

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  method: Maybe<RefundMethod>;
  orderId: Scalars['Int']['output'];
  reason: Maybe<Scalars['String']['output']>;
  stripeAccount: Maybe<Scalars['String']['output']>;
  stripeId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RefundCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<RefundMethod>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RefundFilterInput = {
  AND?: InputMaybe<Array<RefundFilterInput>>;
  NOT?: InputMaybe<Array<RefundFilterInput>>;
  OR?: InputMaybe<Array<RefundFilterInput>>;
  amount?: InputMaybe<FloatFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  method?: InputMaybe<RefundMethodEnumFilter>;
  orderId?: InputMaybe<IntFilterInput>;
  reason?: InputMaybe<StringFilterInput>;
  stripeAccount?: InputMaybe<StringFilterInput>;
  stripeId?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export enum RefundMethod {
  STRIPE = 'STRIPE'
}

export type RefundMethodEnumFilter = {
  equals?: InputMaybe<RefundMethod>;
  in?: InputMaybe<Array<RefundMethod>>;
  not?: InputMaybe<RefundMethodEnumFilter>;
  notIn?: InputMaybe<Array<RefundMethod>>;
};

export type RefundOrderByInput = {
  amount?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  method?: InputMaybe<SortDirection>;
  orderId?: InputMaybe<SortDirection>;
  reason?: InputMaybe<SortDirection>;
  stripeAccount?: InputMaybe<SortDirection>;
  stripeId?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type RefundPagination = {
  __typename?: 'RefundPagination';
  count: Scalars['Int']['output'];
  nodes: Array<Refund>;
};

export type SeatMap = {
  __typename?: 'SeatMap';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  image: Maybe<Image>;
  imageId: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  venueId: Scalars['Int']['output'];
};

export type SeatMapCreateInput = {
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type SeatMapFilterInput = {
  AND?: InputMaybe<Array<SeatMapFilterInput>>;
  NOT?: InputMaybe<Array<SeatMapFilterInput>>;
  OR?: InputMaybe<Array<SeatMapFilterInput>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  events?: InputMaybe<EventListRelationFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venue?: InputMaybe<VenueFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
};

export type SeatMapOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  imageId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venueId?: InputMaybe<SortDirection>;
};

export type SeatMapPagination = {
  __typename?: 'SeatMapPagination';
  count: Scalars['Int']['output'];
  nodes: Array<SeatMap>;
};

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type StringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  mode?: InputMaybe<QueryMode>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  createdAt: Scalars['AWSDateTime']['output'];
  date: Scalars['AWSDateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  expireAt: Maybe<Scalars['AWSDateTime']['output']>;
  file: Maybe<File>;
  fileId: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Maybe<Order>;
  orderId: Scalars['Int']['output'];
  paymentFeeAmount: Scalars['Float']['output'];
  platformFeeAmount: Scalars['Float']['output'];
  platformFeeSubtotalAmount: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  status: Maybe<TicketStatus>;
  ticketNumber: Maybe<Scalars['String']['output']>;
  ticketPool: Maybe<TicketPool>;
  ticketPoolId: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  venueFeeAmount: Scalars['Float']['output'];
  venueFeeSubtotalAmount: Scalars['Float']['output'];
};

export type TicketAggregation = {
  __typename?: 'TicketAggregation';
  count: Scalars['Int']['output'];
  status: TicketStatus;
};

export type TicketCreateInput = {
  eventOccurrenceId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  ticketPoolId?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketFilterInput = {
  AND?: InputMaybe<Array<TicketFilterInput>>;
  NOT?: InputMaybe<Array<TicketFilterInput>>;
  OR?: InputMaybe<Array<TicketFilterInput>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  discountAmount?: InputMaybe<FloatFilterInput>;
  expireAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<IntFilterInput>;
  price?: InputMaybe<FloatFilterInput>;
  status?: InputMaybe<TicketStatusEnumFilter>;
  ticketNumber?: InputMaybe<StringFilterInput>;
  ticketPool?: InputMaybe<TicketPoolFilterInput>;
  ticketPoolId?: InputMaybe<IntFilterInput>;
  totalAmount?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venueFeeAmount?: InputMaybe<FloatFilterInput>;
};

export type TicketListRelationFilterInput = {
  every?: InputMaybe<TicketFilterInput>;
  none?: InputMaybe<TicketFilterInput>;
  some?: InputMaybe<TicketFilterInput>;
};

export type TicketOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  expireAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<OrderOrderByInput>;
  orderId?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
  ticketNumber?: InputMaybe<SortDirection>;
  ticketPoolId?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venueFeeAmount?: InputMaybe<SortDirection>;
};

export type TicketPagination = {
  __typename?: 'TicketPagination';
  count: Scalars['Int']['output'];
  nodes: Array<Ticket>;
};

export type TicketPool = {
  __typename?: 'TicketPool';
  availableBeforeDays: Maybe<Scalars['Int']['output']>;
  availableBeforeTime: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  event: Maybe<Event>;
  eventId: Maybe<Scalars['Int']['output']>;
  expireBeforeDays: Maybe<Scalars['Int']['output']>;
  expireBeforeTime: Maybe<Scalars['String']['output']>;
  hasAnyTicketSold: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isAutoApprove: Scalars['Boolean']['output'];
  isScannerOnly: Scalars['Boolean']['output'];
  maxTicketsPerOrder: Maybe<Scalars['Int']['output']>;
  minTicketsPerOrder: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceWithFees: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  ticketTemplateId: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  venueFee: Scalars['Float']['output'];
};

export type TicketPoolCreateInput = {
  availableBeforeDays?: InputMaybe<Scalars['Int']['input']>;
  availableBeforeTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expireBeforeDays?: InputMaybe<Scalars['Int']['input']>;
  expireBeforeTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAutoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  isScannerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  maxTicketsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  minTicketsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  venueFee?: InputMaybe<Scalars['Float']['input']>;
};

export type TicketPoolFilterInput = {
  AND?: InputMaybe<Array<TicketPoolFilterInput>>;
  NOT?: InputMaybe<Array<TicketPoolFilterInput>>;
  OR?: InputMaybe<Array<TicketPoolFilterInput>>;
  availableBeforeDays?: InputMaybe<IntFilterInput>;
  availableBeforeTime?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  event?: InputMaybe<EventFilterInput>;
  eventId?: InputMaybe<IntFilterInput>;
  expireBeforeDays?: InputMaybe<IntFilterInput>;
  expireBeforeTime?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  isAutoApprove?: InputMaybe<BooleanFilterInput>;
  isScannerOnly?: InputMaybe<BooleanFilterInput>;
  maxTicketsPerOrder?: InputMaybe<IntFilterInput>;
  minTicketsPerOrder?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  price?: InputMaybe<FloatFilterInput>;
  quantity?: InputMaybe<IntFilterInput>;
  ticketTemplateId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venueFee?: InputMaybe<FloatFilterInput>;
};

export type TicketPoolListRelationFilterInput = {
  every?: InputMaybe<TicketPoolFilterInput>;
  none?: InputMaybe<TicketPoolFilterInput>;
  some?: InputMaybe<TicketPoolFilterInput>;
};

export type TicketPoolOrderByInput = {
  availableBeforeDays?: InputMaybe<SortDirection>;
  availableBeforeTime?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  eventId?: InputMaybe<SortDirection>;
  expireBeforeDays?: InputMaybe<SortDirection>;
  expireBeforeTime?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isAutoApprove?: InputMaybe<SortDirection>;
  isScannerOnly?: InputMaybe<SortDirection>;
  maxTicketsPerOrder?: InputMaybe<SortDirection>;
  minTicketsPerOrder?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  ticketTemplateId?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venueFee?: InputMaybe<SortDirection>;
};

export type TicketPoolPagination = {
  __typename?: 'TicketPoolPagination';
  count: Scalars['Int']['output'];
  nodes: Array<TicketPool>;
};

export enum TicketStatus {
  DELETED = 'DELETED',
  NEW = 'NEW',
  SCANNED = 'SCANNED'
}

export type TicketStatusEnumFilter = {
  equals?: InputMaybe<TicketStatus>;
  in?: InputMaybe<Array<TicketStatus>>;
  not?: InputMaybe<TicketStatusEnumFilter>;
  notIn?: InputMaybe<Array<TicketStatus>>;
};

export type TicketTemplate = {
  __typename?: 'TicketTemplate';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ticketPools: Maybe<TicketPoolPagination>;
  updatedAt: Scalars['AWSDateTime']['output'];
  venueId: Scalars['Int']['output'];
};


export type TicketTemplateTicketPoolsArgs = {
  filters?: InputMaybe<TicketPoolFilterInput>;
  orderBy?: InputMaybe<Array<TicketPoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketTemplateCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  ticketPools?: InputMaybe<Array<TicketPoolCreateInput>>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type TicketTemplateFilterInput = {
  AND?: InputMaybe<Array<TicketTemplateFilterInput>>;
  NOT?: InputMaybe<Array<TicketTemplateFilterInput>>;
  OR?: InputMaybe<Array<TicketTemplateFilterInput>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  ticketPools?: InputMaybe<TicketPoolListRelationFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
};

export type TicketTemplateOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  venueId?: InputMaybe<SortDirection>;
};

export type TicketTemplatePagination = {
  __typename?: 'TicketTemplatePagination';
  count: Scalars['Int']['output'];
  nodes: Array<TicketTemplate>;
};

export type TicketTemplateUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  ticketPools?: InputMaybe<Array<TicketPoolCreateInput>>;
};

export type TicketUpdateInput = {
  status?: InputMaybe<TicketStatus>;
};

export type User = UserInterface & {
  __typename?: 'User';
  createdAt: Scalars['AWSDateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  role: UserRole;
  updatedAt: Scalars['AWSDateTime']['output'];
  venueUsers: Maybe<VenueUserPagination>;
};


export type UserVenueUsersArgs = {
  filters?: InputMaybe<VenueUserFilterInput>;
  orderBy?: InputMaybe<Array<VenueUserOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  role: UserRole;
  venueUsers?: InputMaybe<Array<VenueUserCreateInput>>;
};

export type UserFilterInput = {
  AND?: InputMaybe<Array<UserFilterInput>>;
  NOT?: InputMaybe<Array<UserFilterInput>>;
  OR?: InputMaybe<Array<UserFilterInput>>;
  firstName?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  phoneNumber?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UserRoleEnumFilter>;
  venueUsers?: InputMaybe<VenueUserListRelationFilterInput>;
};

export type UserInterface = {
  createdAt: Scalars['AWSDateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  role: UserRole;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UserOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  phoneNumber?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type UserPagination = {
  __typename?: 'UserPagination';
  count: Scalars['Int']['output'];
  nodes: Array<User>;
};

export enum UserRole {
  ADMIN = 'ADMIN',
  CUSTOMER = 'CUSTOMER',
  PARTNER = 'PARTNER'
}

export type UserRoleEnumFilter = {
  equals?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  not?: InputMaybe<UserRoleEnumFilter>;
  notIn?: InputMaybe<Array<UserRole>>;
};

export type UserUpdateInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  venueUsers?: InputMaybe<Array<VenueUserCreateInput>>;
};

export type Venue = {
  __typename?: 'Venue';
  address: Maybe<Address>;
  addressId: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['Int']['output'];
  image: Maybe<Image>;
  imageId: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organization: Maybe<Organization>;
  organizationId: Scalars['Int']['output'];
  platformFee: Scalars['Float']['output'];
  priceDisplay: PriceDisplay;
  stripeAccountId: Maybe<Scalars['String']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type VenueCreateInput = {
  address?: InputMaybe<AddressUpdateInput>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  platformFee?: InputMaybe<Scalars['Float']['input']>;
  priceDisplay?: InputMaybe<PriceDisplay>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type VenueFilterInput = {
  address?: InputMaybe<AddressFilterInput>;
  id?: InputMaybe<IntFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  organization?: InputMaybe<OrganizationsFilterInput>;
  organizationId?: InputMaybe<IntFilterInput>;
  platformFee?: InputMaybe<IntFilterInput>;
  stripeAccountId?: InputMaybe<StringFilterInput>;
};

export type VenueOrderByInput = {
  address?: InputMaybe<AddressOrderByInput>;
  addressId?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  organization?: InputMaybe<OrganizationOrderByInput>;
  organizationId?: InputMaybe<SortDirection>;
  platformFee?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type VenuePagination = {
  __typename?: 'VenuePagination';
  count: Scalars['Int']['output'];
  nodes: Array<Venue>;
};

export type VenueUpdateInput = {
  address?: InputMaybe<AddressUpdateInput>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['Float']['input']>;
  priceDisplay?: InputMaybe<PriceDisplay>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type VenueUser = {
  __typename?: 'VenueUser';
  createdAt: Scalars['AWSDateTime']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  role: VenueUserRole;
  updatedAt: Scalars['AWSDateTime']['output'];
  user: Maybe<User>;
  userId: Scalars['Int']['output'];
  venue: Maybe<Venue>;
  venueId: Scalars['Int']['output'];
};

export type VenueUserCreateInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<VenueUserRole>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type VenueUserFilterInput = {
  AND?: InputMaybe<Array<VenueUserFilterInput>>;
  NOT?: InputMaybe<Array<VenueUserFilterInput>>;
  OR?: InputMaybe<Array<VenueUserFilterInput>>;
  firstName?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<VenueUserRoleEnumFilter>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<IntFilterInput>;
  venue?: InputMaybe<VenueFilterInput>;
  venueId?: InputMaybe<IntFilterInput>;
};

export type VenueUserListRelationFilterInput = {
  every?: InputMaybe<VenueUserFilterInput>;
  none?: InputMaybe<VenueUserFilterInput>;
  some?: InputMaybe<VenueUserFilterInput>;
};

export type VenueUserOrderByInput = {
  createdAt?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  user?: InputMaybe<UserOrderByInput>;
  venue?: InputMaybe<VenueOrderByInput>;
};

export type VenueUserPagination = {
  __typename?: 'VenueUserPagination';
  count: Scalars['Int']['output'];
  nodes: Array<VenueUser>;
};

export enum VenueUserRole {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  STAFF = 'STAFF'
}

export type VenueUserRoleEnumFilter = {
  equals?: InputMaybe<VenueUserRole>;
  in?: InputMaybe<Array<VenueUserRole>>;
  not?: InputMaybe<VenueUserRoleEnumFilter>;
  notIn?: InputMaybe<Array<VenueUserRole>>;
};

export type VenueUserUpdateInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<VenueUserRole>;
};
